import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertService
{
	private subject = new Subject<any>();

	alertMessage: String;
	private keepAfterNavigationChange = false;

	RXJS_ERROR_MESSAGES: string[] = [
		// Core RxJS error types
		"no elements in sequence",                  // EmptyError
		"Too many matching elements",               // SequenceError
		"Timeout has occurred",                     // TimeoutError
		"index is out of range",                    // ArgumentOutOfRangeError
		"element not found",                        // NotFoundError
		"object unsubscribed",                      // ObjectUnsubscribedError

		// Common operator-specific errors
		"combineLatest requires at least one observable",
		"Too few observables passed to withLatestFrom",
		"closingSelector is not a function",
		"condition is not a function",
		"projection is not a function",
		"accumulator function threw an error",
		"Cannot read properties of undefined",      // e.g. map/filter/pluck
		"Cannot read property",                     // old browser message variant
		"Cannot read properties of null",           // e.g. tap/map on null
		"You provided 'undefined' where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.",
		"Iterable cannot be null",
		"Error: inner observable failed",
		"Error: finalize callback threw an error",
		"TypeError: Observable emitted a non-Notification value",

		// Timeout / retry / forkJoin / zip messages
		"Timeout has occurred",
		"no elements in sequence",                  // first(), last(), single() empty
		"Too many matching elements",               // single() multiple matches
		"Error: no elements in sequence",           // sometimes wrapped as Error:

		// General JS runtime messages often propagated through RxJS
		"TypeError",
		"RangeError",
		"ReferenceError",
		"SyntaxError",
		"Cannot read properties",                   // general null/undefined access
		"Cannot read property",
		"is not a function",
		"Invalid time value",
		"undefined is not a function",
		"Cannot convert undefined or null to object",
	];


	constructor(private router: Router, private messageService: MessageService)
	{
		// clear alert message on route change
		router.events.subscribe(event =>
		{
			if (event instanceof NavigationStart)
			{
				if (this.keepAfterNavigationChange)
				{
					// only keep for a single location change
					this.keepAfterNavigationChange = false;
				} else
				{
					// clear alert
					this.subject.next(undefined);
				}
			}
		});
	}

	private toStringMessage(raw: any): string
	{
		if (raw === null || raw === undefined) return '';
		if (typeof raw === 'string') return raw;
		if (raw && typeof raw.message === 'string') return raw.message;
		if (raw && raw.error)
		{
			if (typeof raw.error === 'string') return raw.error;
			if (typeof raw.error.message === 'string') return raw.error.message;
		}
		try { return JSON.stringify(raw); } catch { return String(raw); }
	}

	private isRxjsNoiseMessage(raw: any): boolean
	{
		const text = this.toStringMessage(raw).toLowerCase();
		if (!text) return false;
		return this.RXJS_ERROR_MESSAGES.some(sig => text.includes(sig.toLowerCase()));
	}

	success(alert: any, keepAfterNavigationChange = false)
	{
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({ type: 'success', text: alert });
	}

	error(alert: any, keepAfterNavigationChange = false)
	{
		const messageText = this.toStringMessage(alert);
		// Skip noisy RxJS errors so they don't show in the UI
		if (this.isRxjsNoiseMessage(messageText))
		{
			return;
		}
		console.log('ALERT SERVICE:  message is: ' + messageText);
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({ type: 'error', text: alert });
	}

	warn(message: string) {
		this.messageService.add({
			severity: 'warn',
			summary: 'Warning',
			detail: message,
		});
	}

	getMessage(): Observable<any>
	{
		return this.subject.asObservable();
	}


}
